@if (trade.$tranche()) {

    <!-- TOP SECTION -->
    <div class="x-row -symbol-section">
        <div class="x-symbol-section_col1">
            <div class="x-symbol-section_names">
                <div class="x-symbol-section_names-name">{{trade.$tranche().raw.name}}</div>
                <div class="x-symbol-section_names-symbol">{{trade.$tranche().unitDeliverable.symbol}}</div>
            </div>
            <div class="x-symbol-section_total-values">
                <div class="x-symbol-section_total-values-field">
                    <label class="x-symbol-section_total-values-field-label">
                        Total Value
                    </label>
                    <div class="x-symbol-section_total-values-field-value">
                        <span [displayDecimal]="trade.$tranche().$totalValue() | bigintDeliverableDisplayDecimal:trade.$tranche().$totalValueDeliverable()"></span>
                    </div>
                </div>
                <div class="x-symbol-section_total-values-field">
                    <label class="x-symbol-section_total-values-field-label">
                        Total Units
                    </label>
                    <div class="x-symbol-section_total-values-field-value">
                        <span [displayDecimal]="trade.$tranche().$totalUnits() | bigintDeliverableDisplayDecimal:trade.$tranche().unitDeliverable"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="x-symbol-section_col2">
            <div class="x-symbol-section_quote-field -unit-price">
                <label class="x-symbol-section_quote-field-label">
                    Unit Price
                </label>
                <div class="x-symbol-section_quote-field-value">
                    <span [displayDecimal]="trade.$tranche().$unitPrice() | bigintDeliverableDisplayDecimal:trade.$tranche().unitPriceDeliverable"></span>
                </div>
            </div>
            <div class="x-symbol-section_quote-field -yield">
                <label class="x-symbol-section_quote-field-label">
                    Yield
                </label>
                <div class="x-symbol-section_quote-field-value" [class.-positive]="trade.$tranche().$computedBasePosition()?.yieldPercent > 0" [class.-negative]="trade.$tranche().$computedBasePosition()?.yieldPercent < 0">
                    <span [displayDecimal]="trade.$tranche().$computedBasePosition()?.yieldPercent" [decimalCount]="2" currency="%"></span>
                    <span class="x-symbol-section_quote-field-value-i">ⓘ</span>
                </div>
            </div>
        </div>
    </div>

    <!-- RULES SECTION -->
    <div class="x-row -rules-section">
        <div class="x-rules-section_title">
            Product Rules
        </div>
        <div class="x-rules-section_fields">
            @if (trade.isBuy()) {
                <div class="x-rules-section_field">
                    <label class="x-rules-section_field-label">
                        Minimum Purchase Value
                    </label>
                    <div class="x-rules-section_field-value">
                        <span class="x-rules-section_field-value-i">ⓘ </span>
                        <span [displayDecimal]="trade.$tranche().$trancheRules()?.raw.depositRules.minValue | bigintDeliverableDisplayDecimal:trade.$tranche().$trancheRules()?.valueDeliverable"></span>
                    </div>
                </div>
            } @else if (trade.isSell()) {
                <div class="x-rules-section_field">
                    <label class="x-rules-section_field-label">
                        Maximum Redemption Value
                    </label>
                    <div class="x-rules-section_field-value">
                        <span class="x-rules-section_field-value-i">ⓘ </span>
                        <span [displayDecimal]="trade.$tranche().$trancheRules()?.raw.withdrawalRules.maxPerBatch | bigintDeliverableDisplayDecimal:trade.$tranche().$trancheRules()?.valueDeliverable"></span>
                    </div>
                </div>
            }
            <div class="x-rules-section_field">
                <label class="x-rules-section_field-label">
                    Address Blackout Period
                </label>
                <div class="x-rules-section_field-value">
                    <span class="x-rules-section_field-value-i">ⓘ</span>
                    @let v = (trade.isBuy() ? trade.$depositBlackoutStr() : trade.$withdrawBlackoutStr());
                    @if (v) {
                        {{v}} minutes
                    } @else {
                        —
                    }
                </div>
            </div>
        </div>
    </div>

    <!-- FORM SECTION -->
    <div class="x-row -form-section">
        <div class="x-form-section_cols">
            <div class="x-form-section_col1" [class.-buy]="trade.isBuy()">
                <div class="x-form-section_field">
                    <label class="x-form-section_field-label">
                        Units Held
                    </label>
                    <div class="x-form-section_field-value">
                        @let trancheBalance = trade.$tranche().unitDeliverable | delBalanceAsync:trade.$wallet()?.address | async;
                        @if (trancheBalance) {
                            <span [displayDecimal]="trancheBalance.balance | bigintDeliverableDisplayDecimal:trancheBalance.deliverable"></span>
                        }
                    </div>
                </div>
                @if (trade.isBuy()) {
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            Asset
                        </label>
                        <div class="x-form-section_field-value">
                            <deliverable-input
                                [formControl]="trade.buyForm.controls.asset"
                                [autocompleteConfig]="trade.$buyDelAutocompleteConfig()"
                            />
                        </div>
                    </div>
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label" for="buyQuantity_{{trade.id}}">
                            Quantity
                        </label>
                        <div class="x-form-section_field-value">
                            <decimal-input-wrapper>
                                <input type="text"
                                       [formControl]="trade.buyForm.controls.qty"
                                       [decimal]="trade.buyForm.controls.asset.value?.decimalPlaces"
                                       [min]="trade.buyForm.controls.asset.value?.decimalPlaces | delMinQty"
                                       [step]="trade.buyForm.controls.asset.value?.decimalPlaces | delMinQty"
                                       id="buyQuantity_{{trade.id}}"
                                       decimalInput
                                       autofocus selectAllOnFocus />
                            </decimal-input-wrapper>
                        </div>
                    </div>
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            As USD
                        </label>
                        <div class="x-form-section_field-value">
                            @let refQty = trade.refQtySignal() && (trade.refQtySignal() | async);
                            @let minMax = (trade.$tranche()?.raw.poolTrancheId | delBuyMinMaxQty:trade.buyForm.controls.asset.value | async);
                            <span [displayDecimal]="refQty?.refBalance | bigintDeliverableDisplayDecimal:refQty?.refBalanceDel" [dashIfEmpty]="true"
                                [class.-error]="refQty?.refBalance < minMax?.refMin || refQty?.refBalance > minMax?.refMax">
                            </span>
                        </div>
                    </div>
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            Receive
                        </label>
                        <div class="x-form-section_field-value">
                            @let est = trade.trancheRateEst$ | async;
                            <span [displayDecimal]="est?.refBalance | bigintDeliverableDisplayDecimal:est?.refBalanceDel" [dashIfEmpty]="true"></span>
                        </div>
                    </div>
                } @else if (trade.isSell()) {
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label" for="sellQuantity_{{trade.id}}">
                            Quantity
                        </label>
                        <div class="x-form-section_field-value">
                            <decimal-input-wrapper>
                                <input type="text"
                                       [formControl]="trade.sellForm.controls.qty"
                                       [decimal]="trade.$tranche().unitDeliverable.decimalPlaces"
                                       [min]="trade.$tranche().unitDeliverable.decimalPlaces | delMinQty"
                                       [step]="trade.$tranche().unitDeliverable.decimalPlaces | delMinQty"
                                       id="sellQuantity_{{trade.id}}"
                                       decimalInput
                                       autofocus selectAllOnFocus />
                            </decimal-input-wrapper>
                        </div>
                    </div>
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            Receive
                        </label>
                        <div class="x-form-section_field-value">
                            @let refQty = trade.refQtySignal() && (trade.refQtySignal() | async);
                            <span [displayDecimal]="refQty?.refBalance | bigintDeliverableDisplayDecimal:refQty?.refBalanceDel" [dashIfEmpty]="true">
                            </span>
                        </div>
                    </div>
                }
            </div>
            <div class="x-form-section_col2" [class.-buy]="trade.isBuy()">
                <div class="x-form-section_field -address">
                    <label class="x-form-section_field-label">
                        Address
                    </label>
                    <div class="x-form-section_field-value">
                        @let wAddress = trade.$wallet()?.address;
                        <wallet-avatar
                            class="x-form-section_field-value_avatar"
                            [address]="wAddress"
                            [isChangeOnClickEnabled]="true">
                        </wallet-avatar>
                        <span [copyTooltip]="wAddress">{{wAddress | shortenWalletAddr}}</span>
                    </div>
                </div>
                @if (trade.isBuy()) {
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            Available
                        </label>
                        <div class="x-form-section_field-value">
                            @let refBalance = trade.refBalance$ | async;
                            <span [displayDecimal]="refBalance?.balance | bigintDeliverableDisplayDecimal:refBalance?.balanceDel" [dashIfEmpty]="true"></span>
                            @if (refBalance?.balance && refBalance?.refBalance) {
                                =
                                <span [displayDecimal]="refBalance.refBalance | bigintDeliverableDisplayDecimal:refBalance.refBalanceDel" [dashIfEmpty]="true"></span>
                            }
                        </div>
                    </div>
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            As Units
                        </label>
                        <div class="x-form-section_field-value">
                            @let trRefBalance = trade.trancheRefBalance$ | async;
                            <span [displayDecimal]="trRefBalance?.balance | bigintDeliverableDisplayDecimal:trRefBalance?.balanceDel" [dashIfEmpty]="true"></span>
                            @if (trRefBalance?.balance && trRefBalance?.refBalance) {
                                =
                                <span [displayDecimal]="trRefBalance.refBalance | bigintDeliverableDisplayDecimal:trRefBalance.refBalanceDel" [dashIfEmpty]="true"></span>
                            }
                        </div>
                    </div>
                } @else if (trade.isSell()) {
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            As Value
                        </label>
                        <div class="x-form-section_field-value">
                            @let trRefBalance = trade.trancheRefBalance$ | async;
                            <span [displayDecimal]="trRefBalance?.refBalance | bigintDeliverableDisplayDecimal:trRefBalance?.refBalanceDel" [dashIfEmpty]="true"></span>
                        </div>
                    </div>
                }
                <div class="x-form-section_fields-row">
                    <div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            Fee Estimate
                        </label>
                        <div class="x-form-section_field-value">
                            @let fee = trade.fee$ | async;
                            <span [displayDecimal]="fee?.v | bigintDeliverableDisplayDecimal:fee?.d" [dashIfEmpty]="true"></span>
                            @if (fee?.mathComments) {
                                <span class="x-form-section_field-value-i" [tooltip]="fee.mathComments"> ⓘ</span>
                            }
                        </div>
                    </div>
                    <!-- TODO -->
                    <!--<div class="x-form-section_field">
                        <label class="x-form-section_field-label">
                            [] reject if exceeds
                        </label>
                        <div class="x-form-section_field-value">
                            @if (trade.isBuy()) {
                                <span [displayDecimal]="732 | bigintDisplayDecimal:2:'USDC'"></span>
                            } @else {
                                <span [displayDecimal]="1045 | bigintDisplayDecimal:2:'USD'"></span>
                            }
                        </div>
                    </div>-->
                </div>
                <div class="x-form-section_fields-row">
                    <div class="x-form-section_field -gas-estimate">
                        <label class="x-form-section_field-label">
                            Gas Estimate
                        </label>
                        <div class="x-form-section_field-value">
                            @let estGas = trade.estGasSignal();
                            @if (estGas?.isLoading || trade.$isRequestingAllowance()) {
                                <span class="loading-dot"></span>
                            } @else {
                                <span [displayDecimal]="estGas?.vd?.v | bigintDeliverableDisplayDecimal:estGas?.vd?.d" [dashIfEmpty]="true"></span>

                                @if (trade.isGasNotEstimated()) {
                                    <button class="x-gas-estimate-btn" (click)="trade.onEstimateGasClick($event)">
                                        Estimate
                                    </button>
                                } @else {
                                    <button class="x-gas-estimate-refresh-btn" (click)="trade.onEstimateGasClick($event)">
                                        <svg><use xlink:href="#refresh"></use></svg>
                                    </button>
                                }
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- FOOTER -->
    @let err = trade.$error();
    <div class="x-row -footer" [class.-error]="err && !err.allowanceError" [class.-warn]="err?.allowanceError">
        @if (err) {
            <div class="x-column -error">
                @if (err.dexTxError?.naming) {
                    <span>
                        {{(err.dexTxError.naming.gasMsg || err.dexTxError.naming.msg) | l10n}}
                        @if (err.dexTxError.naming.gasMsgLong || err.dexTxError.naming.msgLong) {
                            <span class="-i" [tooltipL10n]="err.dexTxError.naming.gasMsgLong || err.dexTxError.naming.msgLong">ⓘ</span>
                        }
                    </span>

                    @if (err.allowanceError) {
                        @if (trade.$isRequestingAllowance()) {
                            {{err.dexTxError.naming.action | l10n}}...<span class="loading-dot"></span>
                        } @else {
                            <span class="-action-link"
                                  (click)="trade.onAddAllowance($event)">
                                {{err.dexTxError.naming.action | l10n}}
                            </span>
                            <span class="-action-link"
                                  (click)="trade.onDismissError($event)">
                                {{'Dismiss' | l10n}}
                            </span>
                        }
                    }
                } @else {
                    @let msg = err.dexTxError?.details?.name || err.fallbackErrorMsg || 'Unknown error';
                    <span textHiding [tooltip]="msg">
                        <span>{{msg}}</span>
                    </span>
                }
            </div>
        } @else {
            <div class="x-column -total-block">
                @let est = trade.trancheRateEst$ | async;
                @if (est?.balanceDel) {
                    <span [displayDecimal]="est.balance | bigintDeliverableDisplayDecimal:est.balanceDel" [dashIfEmpty]="true"></span>
                }
                @if (est?.refBalanceDel) {
                    <svg class="total-block_data-separator"><use xlink:href="#convertation-arrow"></use></svg>
                    <span [displayDecimal]="est.refBalance | bigintDeliverableDisplayDecimal:est.refBalanceDel" [dashIfEmpty]="true"></span>
                    @if (est.mathComments) {
                        <span class="-i" [tooltip]="est.mathComments">ⓘ</span>
                    }
                }
            </div>
        }
        <div class="x-column -place-button">
            <button
                class="x-button-large"
                [class.-buy]="trade.isBuy()"
                [class.-sell]="trade.isSell()"
                [disabled]="trade.$isSending()"
                (click)="goToConfirmation()">
                {{trade.isSell() ? 'Redeem' : 'Purchase'}}
            </button>
        </div>
    </div>
}

<ng-container #confirmModalAnchor></ng-container>
